import React from 'react';
import { useIntl } from 'react-intl';

import { ErrorMessage } from 'formik';

import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

import { convertStringToLanguageKey } from 'utils/languageUtils';

import { clientStatuses } from 'components/Client/ClientConstants';

import './AddClientFormView.scss';

const AddClientFormView = ({
    values,
    handleChange,
    errors,
    touched,
    accountManagers,
    countries,
    handleBlur,
}) => {
    const intl = useIntl();

    return (<form className='add-client-form' autoComplete='off'>
        <div className='account-name-field'>
            <TextField
                required
                name='name'
                value={values.name}
                onChange={handleChange}
                label={intl.formatMessage({ id: "company-name" })}
                onBlur={handleBlur}
                error={errors.name && touched.name}
                margin='normal'
                variant='outlined'
                fullWidth
            />
            <ErrorMessage name='name' component='div' className='invalid-field-message' />
        </div>

        <div className='account-manager-field'>
            <TextField
                select
                required
                name='accountManager'
                value={values.accountManager}
                onChange={handleChange}
                label={intl.formatMessage({ id: "account-manager" })}
                onBlur={handleBlur}
                error={errors.accountManager && touched.accountManager}
                margin='normal'
                variant='outlined'
                fullWidth
            >
                {accountManagers.map((accountManager, i) => (
                    <MenuItem
                        native='true'
                        key={i}
                        value={accountManager._id}
                    >
                        {`${accountManager.name}`}
                    </MenuItem>
                ))}
            </TextField>
            <ErrorMessage name='accountManager' component='div' className='invalid-field-message' />
        </div>

        <div className="client-details-block">
            <div className="country-field">
                <TextField
                    select
                    name="country"
                    value={values.country}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label={intl.formatMessage({ id: "country" })}
                    error={errors.country && touched.country}
                    margin="normal"
                    variant="outlined"
                    fullWidth
                >
                    {countries.map((country, i) => (
                        <MenuItem native="true" key={i} value={country.name}>
                            {intl.formatMessage({ id: convertStringToLanguageKey(country.name) })}
                        </MenuItem>
                    ))}
                </TextField>
                <ErrorMessage name="country" component="div" className="invalid-field-message" />
            </div>

            <div className="client-status-field">
                <TextField
                    select
                    required
                    name="status"
                    value={values.status}
                    onChange={handleChange}
                    label={intl.formatMessage({ id: "status" })}
                    error={errors.status && touched.status}
                    onBlur={handleBlur}
                    margin="normal"
                    variant="outlined"
                    fullWidth
                >
                    {clientStatuses.map((status, i) => (
                        <MenuItem
                            native="true"
                            key={i}
                            value={status}
                        >
                            {intl.formatMessage({ id: convertStringToLanguageKey(status) })}
                        </MenuItem>
                    ))}
                </TextField>
                <ErrorMessage name="status" component="div" className="invalid-field-message" />
            </div>
        </div>
    </form>)
};

export default AddClientFormView;
